const LK_Copy =({color,width,height})=>{
    return(
      <svg id="Layer_2"fill={color}  xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 81 81">
      {/* <defs>
        <style>
          .cls-1 {
            fill: #005c8b;
          }
        </style>
      </defs>
      */}
      <g id="Layer_1-2" data-name="Layer_1"> 
        <path class="cls-1" d="M77.54,28.8l-4.91-4.91-3.95-3.95-4.91-4.91-3.46-3.46h-15.43l-3.2-3.2-4.91-4.91-3.46-3.46H0v69.43h27v11.57h54v-46.29h0v-2.45l-3.46-3.46ZM61.32,20.56v-3.08l2.11,2.11,3.35,3.35,2.84,2.84,3.35,3.35,2.11,2.11h-9.52c-2.34,0-4.25-1.91-4.25-4.25v-6.44ZM34.32,8.99v-3.08l2.11,2.11,3.35,3.35.2.2h-5.66v-2.58ZM3.46,65.96V3.46h27.39v8.11h-3.86v54.39H3.46ZM77.54,77.54H30.46V15.04h27.39v11.96c0,4.26,3.45,7.71,7.71,7.71h11.96v42.82Z"/>
      </g>
    </svg>
    );
};

export default LK_Copy;